import dataProvider from "dataProvider";

export const updateManySkus = (skuIds, payload) => {
  dataProvider.updateMany("spare-parts-v2", {
    ids: skuIds,
    data: payload,
  });
};
